import React, { PureComponent } from "react";
import { Claim } from "../../../types";
import "./DetailView.css";
import Overview from "./overview";
import Tasks from "./tasks";
import Invoices from "./invoices";
import Attachments from "./attachments";
import Triage from "./triage";
import ProjectPlan from "./project-plan";
import { TabProps } from "./tabs/types";
import TabsPanel from "./tabs/TabsPanel";
import {
  OVERVIEW_TAB,
  INVOICES_TAB,
  TASKS_TAB,
  PROJECTPLAN_TAB,
  ATTACHMENTS_TAB,
  TRIAGE_TAB
} from "../../appConstants";
import { TabDataType } from "../../../store/types";

type OwnProps = {
  dataSelected: Claim;
  closeDetailView: () => void;
};

type StateProps = {
  selectedTab: TabDataType;
};

type DispatchProps = {
  setSelectedTab: (tab: TabDataType) => void;
};

type DetailViewProps = StateProps & DispatchProps & OwnProps;

export default class DetailView extends PureComponent<DetailViewProps> {
  handleSelection = (tab: TabDataType): void => {
    const { selectedTab, setSelectedTab } = this.props;

    if (tab !== selectedTab) {
      setSelectedTab(tab);
    }
  };

  tabs = (): TabProps[] => {
    const { selectedTab, dataSelected } = this.props;

    return [
      {
        content: <Overview dataSelected={dataSelected} />,
        isSelected: selectedTab === OVERVIEW_TAB,
        key: OVERVIEW_TAB,
        label: "Overview",
        onSelect: () => this.handleSelection(OVERVIEW_TAB)
      },
      {
        content: <Invoices dataSelected={dataSelected} />,
        isSelected: selectedTab === INVOICES_TAB,
        key: INVOICES_TAB,
        label: "Invoices",
        onSelect: () => this.handleSelection(INVOICES_TAB)
      },
      {
        content: <Tasks dataSelected={dataSelected} />,
        isSelected: selectedTab === TASKS_TAB,
        key: TASKS_TAB,
        label: "Tasks",
        onSelect: () => this.handleSelection(TASKS_TAB)
      },
      {
        content: <ProjectPlan dataSelected={dataSelected} />,
        isSelected: selectedTab === PROJECTPLAN_TAB,
        key: PROJECTPLAN_TAB,
        label: "Project Plan",
        onSelect: () => this.handleSelection(PROJECTPLAN_TAB)
      },
      {
        content: <Attachments dataSelected={dataSelected} />,
        isSelected: selectedTab === ATTACHMENTS_TAB,
        key: ATTACHMENTS_TAB,
        label: "Attachments",
        onSelect: () => this.handleSelection(ATTACHMENTS_TAB)
      },
      {
        content: <Triage dataSelected={dataSelected} />,
        isSelected: selectedTab === TRIAGE_TAB,
        key: TRIAGE_TAB,
        label: "Triage",
        onSelect: () => this.handleSelection(TRIAGE_TAB)
      },
    ];
  };

  render() {
    const { dataSelected, closeDetailView } = this.props;

    if (!dataSelected) {
      return null;
    }

    return (
      <div className="close-wrapper">
        <TabsPanel tabs={this.tabs()} />
        <i
          className="fas fa-times"
          onClick={() => closeDetailView()}
          style={{
            cursor: "pointer",
            paddingLeft: "0.5rem",
            color: "#6c757d"
          }}
        />
      </div>
    );
  }
}
